<template lang="pug">
  b-modal(ref="cancel-modal" id="cancelModal" :title="trans('labels.frontend.account.order-single.cancel_order')" hide-footer)
    ul.list-unstyled.cancellation-list
      li
        input.custom-radio.mr-2#reason-one(type='radio' value='not_wanted' name="reason" v-model="reason")
        label(for="reason-one") {{ trans('labels.frontend.account.order-single.cancel-modal.not_wanted') }}
      li
        input.custom-radio.mr-2#reason-two(type='radio' value='found_alternative' name="reason" v-model="reason")
        label(for="reason-two") {{ trans('labels.frontend.account.order-single.cancel-modal.found_alternative') }}
      li
        input.custom-radio.mr-2#reason-three(type='radio' value='not_matched' name="reason" v-model="reason")
        label(for="reason-three") {{ trans('labels.frontend.account.order-single.cancel-modal.not_matched') }}
      li
        input.custom-radio.mr-2#reason-four(type='radio' value='other' name="reason" v-model="reason")
        label(for="reason-four") {{ trans('labels.frontend.account.order-single.cancel-modal.other') }}
        textarea.form-control(:placeholder="trans('labels.frontend.account.order-single.cancel-modal.other_placeholder')" v-model="details")
    button.btn.btn-primary.btn-lg(@click="onSubmit") {{ trans('labels.frontend.account.order-single.cancel_order') }}
</template>

<script>

import { RepositoryFactory } from '../../repositoryFactory';
import notify from '../notify';

const OrderRepository = RepositoryFactory.get('order');

export default {
  props: {
    orderId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      reason: '',
      details: '',
    };
  },
  methods: {
    async onSubmit() {
      try {
        const { data } = await OrderRepository.cancel(this.orderId, {
          reason: this.reason,
          details: this.details,
        }).then((resp) => resp.data);
        this.$emit('canceled', data);
        this.$bvModal.hide('cancelModal');
        notify.message(this, { title: Lang.get('alerts.general.operation_completed'), text: false }, 'success');
      } catch (e) {
        notify.clean().then(() => notify.errors(this, e));
      }
    },
  },
};
</script>
